export enum ENotificationReactionType {
  LIKE = 'LIKE',
}
